import { ApiProvider } from 'providers/request'
import { Organization, OrganizationSettingsParams } from 'models/organization'
import { LegalDocument, LegalDocumentParams } from 'models/legal-document'
import { Invoice } from 'models/invoice'
import { previousPredictiveReports } from 'models/previous-predictive-reports'
import { objectToFormData } from 'utils/object-to-formdata'

export const OrganizationRepository = {
  fetch(): Promise<Organization> {
    return ApiProvider.get('/organization')
  },

  update(data: OrganizationSettingsParams): Promise<Organization> {
    const formData = objectToFormData(data)
    return ApiProvider.patch('/organization', formData)
  },

  fetchLegalDocuments(): Promise<LegalDocument[]> {
    return ApiProvider.get('/organization/legal_documents')
  },

  uploadLegalDocument(id: string, data: LegalDocumentParams): Promise<LegalDocument> {
    const formData = objectToFormData(data)
    return ApiProvider.post(`/organization/legal_documents/${id}`, formData)
  },

  fetchInvoices(): Promise<Invoice[]> {
    return ApiProvider.get('/organization/invoices')
  },

  fetchPreviousPredictiveReports(): Promise<previousPredictiveReports[]> {
    return ApiProvider.get('/organization/previousPredictiveReports')
  },
}
